import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';
import {ActionTypes} from '../actions';
const INITIAL_STATE = {
  'data': [],
  'loading': false,
};
export const reportPartsSalesJapanData = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_COMBOS_DATA_REPORT_TXT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COMBOS_DATA_REPORT_TXT]: (state, action) => {
      downloadFile(action.response.data);
      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.FETCHED_COMBOS_DATA_REPORT_TXT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'data': [],
    }),
  })(state, action);
};
